<template>

  <div class="container">
    <h4 class="subtitle is-size-4">
      {{ documentEditPageTitle }} {{ document.attributes.id }}
    </h4>
    <document-form
      v-if="job.attributes.id"
      :job="job"
      :customer="job.attributes.customer"
      :property="job.attributes.property"
      :attributes="document.form"
      :types="docTypes"
      @onChangeAttribute="assignDocumentFormAttributes"
      @save="commitDocumentEdit"
    >
      <playbook slot="standard-playbook"
        v-if="standardPlaybook.buckets.length"
        :buckets="standardPlaybook.buckets"
        :plays="standardPlaybook.plays"
        @choose="handleStandardPlaybookPlays"
      />
      <playbook slot="optionals-playbook"
        v-if="optionalsPlaybook.buckets.length"
        :buckets="optionalsPlaybook.buckets"
        :plays="optionalsPlaybook.plays"
        @choose="handleOptionalPlaybookPlays"
      />
      <document-form-item-list
        slot="items"
        :items="documentItems"
        @add="addDocumentItem"
        @delete="deleteDocumentItem"
        @update="updateDocumentItem"
        @sort="sortDocumentItems"
      />
      <document-form-item-list
        slot="optionals"
        :optionals="documentOptionals"
        @add="addDocumentOptional"
        @delete="deleteDocumentOptional"
        @update="updateDocumentOptional"
        @sort="sortDocumentOptionals"
      />
      <document-form-item-list
        slot="terms"
        :terms="documentTerms"
        @add="addDocumentTerm"
        @delete="deleteDocumentTerm"
        @update="updateDocumentTerm"
        @sort="sortDocumentTerms"
      />
      <warranty-form
        slot="warranties"
        :warranties="documentWarranties.warranties"
        @add="addWarranty"
        @delete="removeWarranty"
        @update="updateWarranty"
      />

      <div slot="buttons">
        <btn @click="commitDocumentEdit">
          <icon slot="icon" :classes="['fa', 'fa-check']"/>
          Commit
        </btn>
        <btn @click="cancelDocumentEdit">
          <icon slot="icon" :classes="['fa', 'fa-ban']"/>
          Cancel
        </btn>
      </div>

    </document-form>
  </div>

</template>
<script>

  import JobContext from './mixins/JobContext.vue';
  import DocumentContext from './mixins/DocumentContext.vue';
  import DocumentForm from '~/components/document/DocumentForm.vue';
  import DocumentFormItemList from '~/components/document/DocumentFormItemList.vue';
  import WarrantyForm from '~/components/warranty/WarrantyForm.vue';
  import Playbook from '~/components/playbook/Playbook.vue';
  import Btn from '~/components/Btn.vue';
  import Icon from '~/components/Icon.vue';

  let empty = {buckets: [], plays: []};

  /**
   * Transform an API playbook object (with nested buckets/plays)
   * into the flat {buckets, plays} shape that Playbook.vue expects.
   */
  function flattenPlaybook (playbook) {
    if (!playbook || !playbook.buckets) {
      return empty;
    }

    let buckets = playbook.buckets.map(b => ({id: b.id, label: b.label}));
    let plays = playbook.buckets.reduce((acc, bucket) => {
      let items = (bucket.plays || []).map(play => ({
        bucket: bucket.id,
        label: play.label,
        items: play.items,
      }));
      return acc.concat(items);
    }, []);

    return {buckets, plays};
  }

  export default {
    mixins: [JobContext, DocumentContext],
    components: {
      Btn,
      Icon,
      DocumentForm,
      DocumentFormItemList,
      WarrantyForm,
      Playbook,
    },
    computed: {
      standardPlaybook () {
        let match = this.playbookCms.playbooks.find(p => p.name === 'standard');
        return flattenPlaybook(match);
      },
      optionalsPlaybook () {
        let match = this.playbookCms.playbooks.find(p => p.name === 'optionals');
        return flattenPlaybook(match);
      },
    },
    methods: {
      handleStandardPlaybookPlays (items) {
        this.pushDocumentItems(items);
      },
      handleOptionalPlaybookPlays (items) {
        this.pushDocumentOptionals(items);
      },
    },
    mounted () {
      // Clear before the first paint. resetDocumentContext covers the job
      // modules too, so it stands in for both contexts' synchronous half.
      this.resetDocumentContext();

      (async () => {
        await this.initializeJobContext();
        await this.initializeDocumentContext();
      })();
    },
  };

</script>
